import { RowWrapper, TableFilter } from "../types";
import { Order } from "../utils";

export const SELECT = "SELECT";
export const UNSELECT = "UNSELECT";
export const SELECT_ALL = "SELECT_ALL";
export const UNSELECT_ALL = "UNSELECT_ALL";
export const UPDATE_ORDER = "UPDATE_ORDER";
export const UPDATE_ORDER_BY = "UPDATE_ORDER_BY";
export const UPDATE_PAGE = "UPDATE_PAGE";
export const UPDATE_ROWS_PER_PAGE = "UPDATE_ROWS_PER_PAGE";
export const INITIALIZE_TABLE = "INITIALIZE_TABLE";
export const CHECKBOX_FILTER_TABLE = "CHECKBOX_FILTER_TABLE";
export const UPDATE_FILTERS_DATA = "UPDATE_FILTERS";
export const CLEAR_FILTERS_DATA = "CLEAR_FILTERS";
export const UPDATE_CUSTOM_FILTER = "UPDATE_CUSTOM_FILTER";
export const REMOVE = "REMOVE";
export const REMOVE_ROWS = "REMOVE_ROWS";
export const UPDATE_FILTERED_ROWS = "UPDATE_FILTERED_ROWS";
export const CLEAR_FILTERED_ROWS = "CLEAR_FILTERED_ROWS";

export interface Select {
  type: typeof SELECT;
  row: RowWrapper<any>;
}

export interface Remove {
  type: typeof REMOVE;
  row: RowWrapper<any>;
}

export interface RemoveRows {
  type: typeof REMOVE_ROWS;
  rows: { [id: number]: RowWrapper<any> };
}

export interface SelectAll {
  type: typeof SELECT_ALL;
  rows: RowWrapper<any>[];
}

export interface Unselect {
  type: typeof UNSELECT;
  row: RowWrapper<any>;
}

export interface UnselectAll {
  type: typeof UNSELECT_ALL;
}

export interface UpdateOrder {
  type: typeof UPDATE_ORDER;
  orderBy: number;
}

export interface UpdatePage {
  type: typeof UPDATE_PAGE;
  page: number;
}

export interface UpdateRowsPerPage {
  type: typeof UPDATE_ROWS_PER_PAGE;
  rowsPerPage: number;
}

export interface InitializeTable {
  type: typeof INITIALIZE_TABLE;
  rows: RowWrapper<any>[];
}

export interface UpdateFilters {
  type: typeof UPDATE_FILTERS_DATA;
  filtersData: any;
}

export interface ClearFilters {
  type: typeof CLEAR_FILTERS_DATA;
}

export interface UpdateCustomFilter {
  type: typeof UPDATE_CUSTOM_FILTER;
  customFilter: TableFilter;
}

export interface UpdateFilteredRows {
  type: typeof UPDATE_FILTERED_ROWS;
  rows: RowWrapper<any>[];
}

export interface ClearFilteredRows {
  type: typeof CLEAR_FILTERED_ROWS;
}

export interface UpdateCustomFilter {
  type: typeof UPDATE_CUSTOM_FILTER;
  customFilter: TableFilter;
}

export type TableAction =
  | Select
  | Unselect
  | SelectAll
  | UnselectAll
  | UpdateOrder
  | UpdateRowsPerPage
  | UpdatePage
  | InitializeTable
  | UpdateFilters
  | ClearFilters
  | UpdateCustomFilter
  | Remove
  | RemoveRows
  | UpdateFilteredRows
  | ClearFilteredRows;

export interface TableState {
  selectedRows: { [id: number]: RowWrapper<any> };
  searchTerm: string;
  order: Order;
  orderBy: number;
  page: number;
  rowsPerPage: number;
  rows: RowWrapper<any>[];
  rowsFilterTable: RowWrapper<any>[];
  filtersData: any;
  customFilter?: TableFilter;
  selectAll?: boolean;
}

export const initialState: TableState = {
  selectedRows: [],
  searchTerm: "",
  order: "asc",
  orderBy: 0,
  page: 0,
  rowsPerPage: 5,
  rows: [],
  rowsFilterTable: [],
  filtersData: undefined,
  customFilter: undefined,
  selectAll: false,
};

const updateFiltersData = (currentFilters: any, newFilters: any) => {
  return Object.assign({}, currentFilters, newFilters);
};

export const tableReducer = (
  state: TableState = initialState,
  action: TableAction
): TableState => {
  switch (action.type) {
    case SELECT:
      let auxState = {
        ...state,
        selectedRows: { ...state.selectedRows, [action.row.id]: action.row },
      };
      return auxState;
    case UNSELECT:
      const aux = { ...state.selectedRows };
      delete aux[action.row.id];
      return {
        ...state,
        selectedRows: aux,
        selectAll: false,
      };
    case SELECT_ALL:
      let selection: any = {};
      action.rows.forEach((r) => (selection[r.id] = r));
      return {
        ...state,
        selectedRows: selection,
        selectAll: true,
      };
    case UNSELECT_ALL:
      return { ...state, selectedRows: [], selectAll: false };
    case UPDATE_ORDER:
      return {
        ...state,
        order: state.order === "asc" ? "desc" : "asc",
        orderBy: action.orderBy,
      };
    case UPDATE_PAGE:
      return {
        ...state,
        page: action.page,
      };
    case UPDATE_ROWS_PER_PAGE:
      return {
        ...state,
        page: 0,
        rowsPerPage: action.rowsPerPage,
      };
    case INITIALIZE_TABLE:
      return {
        ...state,
        rows: action.rows !== undefined ? action.rows : state.rows,
      };
    case UPDATE_FILTERS_DATA:
      return {
        ...state,
        page: 0,
        filtersData: updateFiltersData(state.filtersData, action.filtersData),
      };
    case CLEAR_FILTERS_DATA:
      return { ...state, filtersData: undefined };
    case UPDATE_CUSTOM_FILTER:
      return { ...state, customFilter: action.customFilter };
    case REMOVE:
      return {
        ...state,
        rows: state.rows.filter((row) => action.row.id !== row.id),
      };
    case REMOVE_ROWS:
      return {
        ...state,
        rows: state.rows.filter(
          (row) =>
            action.rows[row.id] === null || action.rows[row.id] === undefined
        ),
      };
    case UPDATE_FILTERED_ROWS:
      return {
        ...state,
        rowsFilterTable: action.rows,
      };
    default:
      throw new Error();
  }
};
